import FJDropbox from "./FJDropbox";
import FJUtil from "../util/FJUtil";

let FJShareStore = (function () {
  let _isUploadingToDropbox = false;

  return {

    /**
     * @description 停止分享到dropbox
     */
    stopShareToDropbox: function () {
      _isUploadingToDropbox = false;
    },

    /**
     * @desc 上传视频到dropbox并生成分享链接
     * @param data
     * @param videoName
     * @param videoEditor
     * @return {{} | null} {result: true | false, url:string  videoName:string } | null
     * 如果返回值为null，则表示用户中断了上传
     * 如果result为false则表示上传失败，true为成功，并带有生成的分享链接url, videoName为当前用户输出的视频的名字
     */
    uploadToDropbox: function (data, videoName, videoEditor) {
      return new Promise((resolve, reject) => {
        if (!data) {
          reject(new Error('fail'));
        } else if (_isUploadingToDropbox) {
          reject(new Error('sharing'));
        } else {
          _isUploadingToDropbox = true;
          FJDropbox.authentication().then(() => {
            if (_isUploadingToDropbox) {
              FJUtil.ealog('dropbox authorization success');
              let mimeType = "video/mp4";
              let blob = new Blob([data], {type: mimeType});
              return FJDropbox.uploadFile(blob, new Date().getTime() + ".mp4", false);
            } else {
              return Promise.reject(new Error('abort'));
            }
          }).then((data) => {
            if (_isUploadingToDropbox) {
              if (data.result) {
                return FJDropbox.createShareLinkFromPath(data.response.path_lower);
              } else {
                return Promise.reject(new Error('fail'));
              }
            } else {
              return Promise.reject(new Error('abort'));
            }
          }).then((shareData) => {
            if (_isUploadingToDropbox) {
              if (shareData.result) {
                let shareLink = shareData.shareLink.replace("?dl=0", "");
                let url = "www.flexclip.com" !== document.domain ? "https://www.smartvideomaker.com" : "https://www.flexclip.com";
                url += "/editor/share?url=" + encodeURIComponent(shareLink);
                if (videoEditor) url += encodeURIComponent("&editor=" + videoEditor);
                resolve({result: true, url: url, videoName: videoName || "Untitled"});
              } else {
                return Promise.reject(new Error('fail'));
              }
            } else {
              return Promise.reject(new Error('abort'));
            }
          }).catch((e) => {
            console.log(e);
            FJUtil.ealog('dropbox authorization fail');
            reject(e);
          }).finally(() => {
            _isUploadingToDropbox = false;
          });
        }
      })
    },

    /**
     * @description 分享youtube
     * @param data
     * @param videoName
     * @param progressCallback
     * @return {Promise<unknown>}
     */
    shareVideoToYoutube: function (data, videoName, progressCallback) {
      return new Promise((resolve, reject) => {
        let mimeType = "video/mp4";
        let blob = new Blob([data], {type: mimeType});
        if (window.youtubeShare) {
          if (window.youtubeShare.reloadApiLock) {
            reject(new Error('no youtube'));
          } else {
            window.youtubeShare.shareVideo(blob, videoName, progressCallback)
              .then(resolve)
              .catch(reject);
          }
        } else {
          reject(new Error('no youtube'));
        }
      });
    },

    /**
     * @description 取消youtube分享
     */
    cancelShareVideoToYoutube: function () {
      if (window.youtubeShare) {
        window.youtubeShare.cancel();
      }
    },
  }
})();

export default FJShareStore;